export default "__VITE_ASSET__CGvzXQEj__"